import React, { ReactNode } from "react";
import "../../assets/scss/components/generic/loader.scss";
import loaderImage from "../../assets/images/loading-refresh.gif";
export interface ILoaderProps {
  color?: string;
  size: number;
}

export const SLoader = (size: number, color: string): ReactNode => {
  return (
    <div className="loaderWrap">
      <Loader color={color} size={size} />
    </div>
  );
};

const Loader: React.FC<ILoaderProps> = (props: ILoaderProps) => {
  let color = props.color || "white";
  return (
    <div className="loaderImageWrap">
      <img src={loaderImage} />
    </div>
  );
};
export const PageLoader: React.FC<ILoaderProps> = (props: ILoaderProps) => {
  let color = props.color || "white";
  return (
    <div className="pageLoaderScreen loaderImageWrap">
      <img src={loaderImage} />
    </div>
  );
};

export default Loader;
